<!--
 * @Description:
 * @Author: wjx
 * @Github:
 * @LastEditors: Please set LastEditors
 * @Date: 2019-02-28 15:17:18
 * @LastEditTime: 2022-03-23 11:31:06
 -->
<template>
  <div class="box">
    <el-form
      class="login"
      ref="formInline"
      :model="formInline"
      :rules="ruleInline"
    >
      <div style="font-size:16px;color:rgba(51,51,51,1);line-height:21px;">
        手机号码登录
      </div>
      <el-form-item prop="phone">
        <el-input
          v-model.trim="formInline.phone"
          placeholder="输入手机号"
          clearable
        />
      </el-form-item>
      <el-form-item prop="imgVerifyCode" v-show="showFlag" class="quaBox">
        <el-input
          v-model="formInline.imgVerifyCode"
          placeholder="输入图形验证码"
          clearable
          class="login-input"
        />
        <img :src="imgUrl" alt class="imgVerify" @click="changeEwm" />
      </el-form-item>
      <el-form-item prop="verifyCode" class="quaBox">
        <el-input
          v-model="formInline.verifyCode"
          placeholder="输入验证码"
          clearable
          class="login-input"
        />
        <el-button
          class="login-bts2"
          @click="getSms"
          :disabled="sendFlag"
          :loading="ifBtnLoad"
        >
          {{ sendText }}
        </el-button>
      </el-form-item>
      <el-checkbox v-model="allowFlag" class="login-check">
        <span style="color:#666666;">我同意遵守</span>
        <router-link to="/about" style="color:#1989FA;cursour:pointer">
          《向日葵服务平台用户协议》
        </router-link>
      </el-checkbox>
      <el-button
        type="primary"
        class="login-bts"
        :disabled="!allowFlag"
        @click="reg"
        :loading="ifBtnLoad"
      >
        立即登录
      </el-button>
    </el-form>
    <Protocol v-if="showProtocol" @close="closeProtocol"></Protocol>
    <div class="toast" v-show="showToast > 0">
      <div class="toastTit" v-if="showToast == 1">
        您还未完成企业认证，请前往
        <br />
        “向日葵学术服务众包B2B平台”
        <br />
        完成企业认证。
      </div>
      <div v-else class="toastTit">
        您还未签约《向日葵平台服务
        <br />
        框架合同》，请前往”向日葵学术
        <br />
        服务众包B2B平台“签约该合同。
      </div>
      <div class="toastBtn">
        <el-button type="primary" class="cancel" @click="cancel">
          取消
        </el-button>
        <el-button type="primary" v-if="showToast == 1" @click="goSun(1)">
          前往认证
        </el-button>
        <el-button type="primary" v-else @click="goSun(2)">前往签约</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { login } from '@/api/ajax';
import { mapActions } from 'vuex';
import { getStorage } from '@/tools/storage';
import Protocol from './components/Protocol';

export default {
  name: '',
  components: {
    Protocol
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!/^1\d{10}$/.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    const validateVerifyCode = (rule, value, callback) => {
      if (!this.checkVerify) {
        callback();
      } else {
        if (value) {
          callback();
        } else {
          callback(new Error('短信验证码不正确'));
        }
      }
    };
    return {
      showProtocol: false,
      ifBtnLoad: false,
      timer: null,
      imgUrl: '', //图形验证码
      showFlag: false,
      formInline: {
        phone: '',
        imgVerifyCode: '',
        verifyCode: ''
      },
      sendFlag: false,
      sendText: '获取验证码',
      checkVerify: false, //是否校验短信码
      ruleInline: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        imgVerifyCode: [
          { required: true, message: '图片验证码不能为空', trigger: 'blur' }
        ],
        verifyCode: [{ validator: validateVerifyCode, trigger: 'blur' }]
      },
      phoneNum: '',
      quaNum: '',
      allowFlag: true,
      showToast: 0
    };
  },
  methods: {
    ...mapActions(['GetUserRoles']),
    cancel() {
      this.showToast = 0;
    },
    goSun(type) {
      let host = '';
      if (/192.168|jimijiayuan/.test(location.href)) {
        host = 'http://saas-sun-pc.jimijiayuan.cn';
      } else {
        host = '//myxrk.com';
      }
      if (type == 1) {
        location.href = `${host}/#/qua`;
      } else {
        location.href = `${host}/#/personal/my_contract`;
      }
    },
    changeEwm() {
      //更换二维码
      this.imgUrl = `${login.verifyImgCode}?phone=${
        this.formInline.phone
      }&v=${new Date().getTime()}`;
    },
    reg() {
      //注册
      this.checkVerify = true;
      this.$refs['formInline'].validate(valid => {
        if (valid) {
          localStorage && localStorage.clear();
          login.login(this.formInline).then(res => {
            if (res.data.data.isAuthStatus != 2) {
              this.showToast = 1;
            } else {
              this.GetUserRoles(res).then(() => {
                this.$router.push({
                  path: '/home'
                });
              });
            }
          });
        }
      });
    },
    getSms() {
      //获取短信
      this.checkVerify = false;
      if (!this.sendFlag) {
        this.$refs['formInline'].validate(valid => {
          if (valid) {
            this.sendFlag = true;
            this.sendText = 60;
            this.timer = setInterval(() => {
              if (this.sendText > 0) {
                this.sendText -= 1;
              } else {
                clearInterval(this.timer);
                this.sendText = '获取验证码';
                this.sendFlag = false;
              }
            }, 1000);
            login
              .sendMessageCode(this.formInline)
              .then(res => {
                this.$message({
                  showClose: true,
                  message: res.data.message,
                  type: 'success'
                });
                this.formInline.verifyCode = res.data.data;
              })
              .catch(e => {
                clearInterval(this.timer);
                this.sendText = '获取验证码';
                this.sendFlag = false;
                this.imgUrl = `${login.verifyImgCode}?phone=${
                  this.formInline.phone
                }&v=${new Date().getTime()}`;
              });
          }
        });
      }
    },
    closeProtocol() {
      this.showProtocol = false;
    }
  },
  watch: {
    'formInline.phone'(v) {
      if (/^1\d{10}$/.test(this.formInline.phone)) {
        this.imgUrl = `${login.verifyImgCode}?phone=${
          this.formInline.phone
        }&v=${new Date().getTime()}`;
        this.showFlag = true;
      } else {
        this.showFlag = false;
      }
    }
  },
  created() {},
  mounted() {
    localStorage && localStorage.clear();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>
<style lang="scss" scoped>
.box {
  background-image: url('//cdn.yxvzb.com/WEB/SaaS/images/login-bg.png');
  background-size: 100% 100%;

  width: 100%;
  height: 100vh;
  .bg {
    width: 1920px;
    height: 1080px;
  }
  .login {
    position: absolute;
    right: 9.75%;
    top: 23.43%;
    width: 446px;
    min-height: 390px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    padding: 77px 63px;
    > * {
      margin-bottom: 20px;
    }
    .login-input {
      width: 170px;
      margin-right: 5px;
      height: 40px;
    }
    .imgVerify {
      width: 140px;
      height: 40px;
    }
    .login-bts2 {
      width: 140px;
      height: 40px;
      border-radius: 2px;
      border-color: rgba(25, 137, 250, 1);
      color: #1989fa;
      display: inline-block;
    }
    .login-bts {
      width: 100%;
      height: 40px;
      font-size: 14px;
      border-radius: 2px;
    }
    .login-check {
      display: flex;
      align-items: center;
    }
  }
  .quaBox {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .toast {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 444px;
    height: 276px;
    background: #fff;
    border-radius: 12px;
    padding: 43px 57px 30px;
    box-sizing: border-box;
    margin-left: -220px;
    margin-top: -138px;
    z-index: 10;
    .toastTit {
      font-size: 22px;
      line-height: 38px;
      color: #2e2f2f;
      text-align: center;
      margin-bottom: 47px;
    }
    .toastBtn {
      display: flex;
      justify-content: space-between;
      .cancel {
        color: #1989fa;
        background: #fff;
        border: 1px solid #1989fa;
      }
    }
  }
}
</style>
